import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import { Pie,Line } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend,CategoryScale,LinearScale,LineElement,Title,PointElement} from 'chart.js';
Chart.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

let source = axios.CancelToken.source();

class RAG extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            totalkm: 0,
            totaldur: 0,
            sevendayvio:[],
            sevenday:[],
            ragobj:{},
            ragload:false,
        }
    }
    componentDidMount() {
        let baseurl = myconfig.getdashboard3;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    totalkm: res.data.totalkm,
                    totaldur: res.data.totaldur,
                    sevendayvio:res.data.sevendayvio,
                    sevenday:res.data.sevenday,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
        baseurl = myconfig.sevendayeco;
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    ragobj:res.data,
                    ragload:true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    menuhidden=(event)=>{
        event.preventDefault();
        if(this.state.menu=="g-sidenav-show bg-gray-100")
            this.setState({
                menu:"g-sidenav-show bg-gray-100 g-sidenav-pinned"
            })
        else
            this.setState({
                menu:"g-sidenav-show bg-gray-100"
            })
    }
    chart=()=> {
        let retdata=this.state.sevenday.map(value => {
            let data = {
                datasets: [
                    {
                        label: '# of Violation',
                        data: [value.green,value.yellow, value.red],
                        backgroundColor: [
                            'rgba(0, 255, 0, 1)',
                            'rgba(255, 194, 0 ,1)',
                            'rgba(255, 0, 0, 1)',
                        ],
                        borderColor: [
                            'rgba(0, 255, 0, 1)',
                            'rgba(255, 194, 0,1)',
                            'rgba(255, 0, 0, 1)',
                        ],
                        borderWidth: 1,
                    },
                ],
            };
            return (<div className="col-md-3 col-lg-2">
                <div className="card  mb-4">
                    <div className="card-body p-3">
                        <div className="row">
                            <div className="col-12">
                                <div className="numbers">
                                    <p className="text-sm mb-0 text-uppercase font-weight-bold">{value.label}</p>
                                </div>
                            </div>
                            <div className="col-12 text-end">
                                <Pie data={data}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)
        })
        return (<>{retdata}</>)
    }
    chartline=()=> {
        let label = [];
        let datavalue = [];
        this.state.sevendayvio.map(value => {
            label.push(value.label)
            datavalue.push(value.totalvio)
        })
        let data = {
            labels: label,
            datasets: [
                {
                    label: "RAG",
                    data: datavalue,
                    fill: true,
                    backgroundColor: "rgba(0,255,0,1)",
                    borderColor: "rgba(0,255,0,1)",
                }
            ]
        };
        return (<Line data={data}/>)
    }
    rag=()=> {
        let retdata = null;
        if (this.state.ragload) {
            let data = {
                labels: ['Red', 'Amber', 'Green', 'Not-Working'],
                datasets: [
                    {
                        label: 'RAG Report',
                        data:
                            [
                                this.state.ragobj.red.length,
                                this.state.ragobj.yellow.length,
                                this.state.ragobj.green.length,
                                this.state.ragobj.notworking.length
                            ],
                        backgroundColor: [
                            'rgba(255, 0, 0, 1)',
                            'rgba(255, 194, 0 ,1)',
                            'rgba(0, 255, 0, 1)',
                            'rgba(220,220,220, 1)',
                        ],
                        borderColor: [
                            'rgba(255, 0, 0, 1)',
                            'rgba(255, 194, 0 ,1)',
                            'rgba(0, 255, 0, 1)',
                            'rgba(220,220,220, 1)',
                        ],
                        borderWidth: 1,
                    },
                ],
            };
            let tabledataamber=this.state.ragobj.yellow.map(value=>{
                return <tr style={{backgroundColor:"rgba(255, 194, 0 ,1)", color:"white"}}>
                    <td>{value.plateno}</td>
                    <td>{value.s}</td>
                    <td>{value.a}</td>
                    <td>{value.b}</td>
                    <td>{value.c}</td>
                    <td>{(value.s+value.a+value.b+value.c)}</td>
                </tr>
            })
            let tabledatared=this.state.ragobj.red.map(value=>{
                return <tr style={{backgroundColor:"rgba(255, 0, 0, 1)", color:"white"}}>
                    <td>{value.plateno}</td>
                    <td>{value.s}</td>
                    <td>{value.a}</td>
                    <td>{value.b}</td>
                    <td>{value.c}</td>
                    <td>{(value.s+value.a+value.b+value.c)}</td>
                </tr>
            })
            retdata = <>
                <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="card z-index-2 h-100">
                        <div className="card-header pb-0 pt-3 bg-transparent">
                            <h6 className="text-capitalize">RAG Chart</h6>
                            <p className="text-sm mb-0">
                                <span className="font-weight-bold">Previous</span> 7 days
                            </p>
                        </div>
                        <div className="card-body p-3">
                            <div className="chart">
                                <Pie data={data}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="card z-index-2 h-100">
                        <div className="card-header pb-0 pt-3 bg-transparent">
                            <h6 className="text-capitalize">RAG Data</h6>
                            <p className="text-sm mb-0">
                                <span className="font-weight-bold">Amber</span> Data
                            </p>
                        </div>
                        <div className="card-body p-3">
                            <div className="chart">
                                <div className="dataTable-container  overflow-auto" style={{height: '400px'}}>
                                    <table className="table table-flush dataTable-table"
                                           id="products-list">
                                        <thead>
                                        <tr>
                                            <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Plate No</th>
                                            <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Speed</th>
                                            <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Acceleration</th>
                                            <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Braking</th>
                                            <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Cornering</th>
                                            <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tabledataamber}
                                        {tabledatared}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        }
        return (<>{retdata}</>)
    }
    render() {
        return (
            <>
                <div className="min-height-300 bg-primary position-absolute w-100"></div>
                <div className={this.state.menu}>
                    <Nav type="rag"/>
                    <main className="main-content position-relative border-radius-lg ">
                        {/* Navbar */}
                        <nav className="navbar navbar-main navbar-expand-lg  px-0 mx-4 shadow-none border-radius-xl z-index-sticky " id="navbarBlur" data-scroll="false">
                            <div className="container-fluid py-1 px-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                                        <li className="breadcrumb-item text-sm">
                                            <a className="text-white" href="#">
                                                <i className="ni ni-box-2" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item text-sm text-white"><a className="opacity-5 text-white" href="#">Dashboard</a></li>
                                    </ol>
                                    <h6 className="font-weight-bolder mb-0 text-white">RAG</h6>
                                </nav>
                                <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                                    <a href="#" onClick={this.menuhidden} className="nav-link p-0">
                                        <div className="sidenav-toggler-inner">
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                        </div>
                                    </a>
                                </div>
                                <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                                        <div className="input-group">
                                            <span className="input-group-text text-body"><i className="fas fa-search" aria-hidden="true" /></span>
                                            <input type="text" className="form-control" placeholder="Type here..." />
                                        </div>
                                    </div>
                                    <ul className="navbar-nav  justify-content-end">
                                        <li className="nav-item d-flex align-items-center">
                                            <a href="" className="nav-link text-white font-weight-bold px-0">
                                                <i className="fa fa-user me-sm-1" />
                                                <span className="d-sm-inline d-none">ncapi</span>
                                            </a>
                                        </li>
                                        <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                                            <a href="#" className="nav-link text-white p-0" onClick={this.menuhidden}>
                                                <div className="sidenav-toggler-inner">
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        {/* End Navbar */}
                        <div className="container-fluid py-4">
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="card shadow-lg">
                                        <div className="card-body px-5 z-index-1 bg-cover">
                                            <div className="row">
                                                <div className="col-lg-3 col-12 my-auto">
                                                    <h4 className="text-body opacity-9 text-center">7 day's RAG Report</h4>
                                                    <hr className="horizontal light mt-1 mb-3"/>
                                                    <div className="d-flex justify-content-center">
                                                        <div>
                                                            <h6 className="mb-0 text-body opacity-7">Millage</h6>
                                                            <h3 className="text-body">{this.state.totalkm} <small
                                                                className="text-sm align-top">KM</small></h3>
                                                        </div>
                                                        <div className="ms-lg-6 ms-4 text-center">
                                                            <h6 className="mb-0 text-body opacity-7">Engine</h6>
                                                            <h3 className="text-body">{this.state.totaldur} <small
                                                                className="text-sm align-top">Hour's</small></h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-12 text-center">
                                                    <img className="w-75 w-lg-100 mt-n7 mt-lg-n8 d-none d-md-block"
                                                         src="img/driver.png" alt="car image"/>
                                                    <div className="d-flex align-items-center">
                                                        <h4 className="text-body opacity-7 ms-0 ms-md-auto">Driver's Behaviour</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                {this.chart()}
                            </div>
                            <div className="row">
                                {this.rag()}
                            </div>
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="card  mb-4">
                                        <div className="card-body p-3">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="numbers">
                                                        <p className="text-sm mb-0 text-uppercase font-weight-bold">4</p>
                                                    </div>
                                                </div>
                                                <div className="col-12 text-end">
                                                    {this.chartline()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <footer className="footer pt-3  ">
                                <div className="container-fluid">
                                    <div className="row align-items-center justify-content-lg-between">
                                        <div className="col-lg-6 mb-lg-0 mb-4">
                                            <div className="copyright text-center text-sm text-muted text-lg-start">
                                                © 2022,
                                                made with <i className="fa fa-heart" aria-hidden="true"/> by
                                                <a href="#" className="font-weight-bold"> ZTS Ethiopia</a>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <ul className="nav nav-footer justify-content-center justify-content-lg-end">
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link text-muted">ZTS Ethiopia</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link text-muted">About Us</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link pe-0 text-muted">License</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        </div>
                    </main>
                </div>

            </>
        )
    }
}

export default RAG;
